export const getDataLayer = () =>
  typeof window !== 'undefined' && window.dataLayer;
export const isNewUser = () =>
  typeof window !== 'undefined' &&
  window.manomano &&
  window.manomano.isNewUser &&
  typeof window.manomano.isNewUser === 'function'
    ? window.manomano.isNewUser()
    : false;
export const getUser = () =>
  typeof window !== 'undefined' && window.manomano && window.manomano.user;
